import { createTest, fetchTestBankItem } from "../../api/backend";

/** Map a knowledge-bank test into a course createTest payload (class-level). */
export function bankTestToCoursePayload(item = {}) {
  let questions = item.questions ?? [];
  if (typeof questions === "string") {
    try {
      questions = JSON.parse(questions || "[]");
    } catch {
      questions = [];
    }
  }
  if (!Array.isArray(questions)) questions = [];

  const payload = {
    title: item.title || "Untitled Test",
    description: item.description || "",
    questions,
    passingScore: item.passingScore != null ? item.passingScore : 80,
    timeLimitMinutes: item.timeLimitMin ?? item.timeLimitMinutes ?? null,
    sourceTestBankId: item.id ?? null,
  };
  const retakes = item.maxRetakes;
  if (retakes != null && Number(retakes) >= 1) {
    payload.maxRetakes = Number(retakes);
  }
  return payload;
}

/**
 * Clone a bank test into the course as a class-level Test.
 * Coordinator can then move it to a session like any other test.
 */
export async function assignBankTestAsClassLevel(courseId, item) {
  let source = item;
  if (item?.questions == null && item?.id != null) {
    source = await fetchTestBankItem(item.id);
  }
  return createTest(courseId, bankTestToCoursePayload(source));
}
